import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import About from "./page/About";
import CheckOutPage from "./page/CheckOutPage";
import ContactPage from "./page/ContactPage";
import FaqPage from "./page/FaqPage";
import OnlineCourseDetail from "./page/CourseDetail";
import Courses from "./page/Courses";
import LandingPage from "./page/LandingPage/index";
import LandingPageV2 from "./page/LandingPageV2/index";
import LiveCourses from "./page/LiveCourse";
import CourseDetailV2 from "./page/CourseDetailV2/index";
import Payment from "./page/Payement";
import SuccessfulPage from "./page/SuccessfulPage";
import ScholarshipDetail from "./page/ScholarshipDetail/index";
import ScholarshipPay from "./page/ScholarshipPay/index";
import ScholarshipPaymentStatus from "./page/ScholarshipPaymentStatus/index";
import Scholarships from "./page/Scholarships/index";
import DashboardLayout from "./layout/DashboardLayout";
import { StandaloneGuard } from "./pwa";

import NotFound from "./page/NotFound";

import MyCourse from "./components/Dashboard/MyCourse";
import PrivateRoute from "./components/PrivateRoute";
import Callback from "./page/Callback";
// eslint-disable-next-line no-unused-vars
import LiveCourseDetailPage from "./page/LiveCourseDetails";

import Preloader from "./components/preloader";

import VerifyEmailComponent from "./components/VerifyEmailComponent";

// VoN
import { GoogleOAuthProvider } from "@react-oauth/google";
import { logEvent } from "firebase/analytics";
import VonAllCourses from "./components/AllVon/VonAllCourses/VonAllCourses";
import VonVerifyEmail from "./components/AllVon/VonVerifyEmail/VonVerifyEmail";
import DashBoardNew from "./components/Dashboard/DashBoardNew";
import Settings from "./components/Dashboard/Settings";
import Projects from "./components/Dashboard/Projects";
import VerifyEmail from "./components/VerifyEmailComponent";
import { GlobalContext } from "./context";
import { FetchUserCoureses } from "./context/actions/courses";
import { analytics } from "./firebase";
import "./global.css";
import UploadAnswers from "./page/Assignments/UploadAnswers";
import AugustCohort from "./page/AugustCohort";
import AugustWaitListv2 from "./page/AugustWaitListv2";
import BaRegistration from "./page/Ba-Registration";
import BecomeASposor from "./page/BecomeASposor";
import Community from "./page/Community";
import DataAnalyst from "./page/DataAnalyticsForm";
import Engagement from "./page/Engagement";
import FeedBack from "./page/FeedBack";
import Instructors from "./page/Instructors/Instructors";
import JanuaryWaitList from "./page/JanuaryWaitList";
import Nysc from "./page/Nysc";
import PrivacyPolicy from "./page/PrivacyPolicy";
import ProjectPage from "./page/Projects/Index";
import Sponsor from "./page/Sponsor";
import SponsorApply from "./page/Sponsor-Apply";
import SummerForm from "./page/SummerForm";
import ForgottenPasswordPage from "./page/auth/ForgottenPassword";
import ResetPasswordPage from "./page/auth/ResetPassword";
import SignUpPage from "./page/auth/SignUp";
import LoginPage from "./page/auth/login";
import { getDescriptiveName } from "./utility";
import Opportunity from "./page/Opportunity/Opportunity";
import ConfirmationPage from "./page/Opportunity/Components/ConfirmationPage";
import Login from "./page/Opportunity/Components/LoginPage";
import ConsultForm from "./page/Consultancy/ConsultForm";
import VerifyCertificate from "./page/VerifyCertificate";
import Certificates from "./components/Dashboard/Certificates";
import SuccessPage from "./page/Consultancy/SuccessMsg";
import CohortEnrollment from "./page/Cohorts/CohortEnrollment";
import CheckoutCallback from "./page/Cohorts/CheckoutCallback";
import CoursePageSwitch from "./components/Dashboard/learn/CoursePageSwitch";
import StudentPageSwitch from "./components/Dashboard/learn/StudentPageSwitch";
import StudentGradesPage from "./components/Dashboard/learn/GradesPage";
import StudentProjectsPage from "./components/Dashboard/learn/ProjectsPage";
import StudentSettingsPage from "./components/Dashboard/learn/SettingsPage";
import StudentMyCoursesPage from "./components/Dashboard/learn/MyCoursesPage";
import StudentCertificatesPage from "./components/Dashboard/learn/CertificatesPage";
import StudentJobBoardPage from "./components/Dashboard/learn/JobBoardPage";
import StudentCvReviewerPage from "./components/Dashboard/learn/CvReviewerPage";
import StaffProgressPage from "./components/Dashboard/learn/staff/StaffProgressPage";
import StaffCertificatesPage from "./components/Dashboard/learn/staff/StaffCertificatesPage";
import StaffPlansPage from "./components/Dashboard/learn/staff/StaffPlansPage";
import StaffPlanPage from "./components/Dashboard/learn/staff/StaffPlanPage";
import StaffWeekPage from "./components/Dashboard/learn/staff/StaffWeekPage";
import StaffQuizPage from "./components/Dashboard/learn/staff/StaffQuizPage";
import StaffCapstonePage from "./components/Dashboard/learn/staff/StaffCapstonePage";
import StaffLivePage from "./components/Dashboard/learn/staff/StaffLivePage";
import StaffLeaderboardPage from "./components/Dashboard/learn/staff/StaffLeaderboardPage";
import SubscriptionsPage from "./page/Dashboard/SubscriptionsPage";
import InstructorCourses from "./components/Dashboard/InstructorCourses";
import InstructorSubmissions from "./components/Dashboard/InstructorSubmissions";
import LeaderboardPage from "./page/Leaderboard/index";
import GradesPage from "./page/Grades/index";
import SubmissionViewerPage from "./page/Dashboard/SubmissionViewerPage";
import CvReviewPage from "./page/CvReview/index";
import JobBoardPage from "./page/JobBoard/index";
import InstructorAcceptInvite from "./page/InstructorAcceptInvite";
import AdminAcceptInvite from "./page/AdminAcceptInvite";
import ScholarshipsPage from "./page/Admin/ScholarshipsPage";
import AnalyticsPage from "./page/Admin/AnalyticsPage";
import ScholarshipApplicationsPage from "./page/Admin/ScholarshipApplicationsPage";
import AdminSchedulesPage from "./page/Admin/AdminSchedulesPage";
import AdminCommentsPage from "./page/Admin/AdminCommentsPage";
import AdminFeedbackPage from "./page/Admin/AdminFeedbackPage";
import AdminSponsorsPage from "./page/Admin/AdminSponsorsPage";
import AdminPartnersPage from "./page/Admin/AdminPartnersPage";
import AdminFaqsPage from "./page/Admin/AdminFaqsPage";
import AdminJobsPage from "./page/Admin/AdminJobsPage";
import AdminLeaderboardPage from "./page/Admin/AdminLeaderboardPage";
import StudentsPage from "./page/Admin/StudentsPage";
import AdminSubscriptionsPage from "./page/Admin/SubscriptionsPage";
import AdminCoursesPage from "./page/Admin/AdminCoursesPage";
import AdminCohortsPage from "./page/Admin/AdminCohortsPage";
import AdminCohortCoursesPage from "./page/Admin/AdminCohortCoursesPage";
import AdminCohortSchedulesPage from "./page/Admin/AdminCohortSchedulesPage";
import InstructorLeaderboardPage from "./page/Admin/InstructorLeaderboardPage";
import MultiStepForm from "./page/Opportunity/MultiStepForm";
import Events from "./page/Events/Events";
import Categories1 from "./page/Category/Categories1";
import CoursePage from "./page/Category/CoursePage";
import Blog from "./page/Blog/Blog";
import BlogDetails from "./page/Blog/BlogDetails";
import AlumniStory from "./page/AlumniStory/AlumniStory";
// import VonNewsletter1 from "./components/AllVon/VonNewsletter/VonNewsletter1";
import { BlogProvider } from "./services/BlogContext";
import Consultancy from "./page/Consultancy/Consultancy";
import { TrainersProvider } from "./services/TrainersContext";
import Schedule from "./page/Beta-Cohort-Schedule";
import PioneerCohortSchedule from "./page/Pioneer-Cohort-Schedule";
import PartnerProgram from "./page/PartnerProgram";
import TermsAndCondition from "./page/Privacy/Terms";

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    const pageTitle = getDescriptiveName(location.pathname);

    logEvent(analytics, "page_view", {
      page_path: pagePath,
      page_title: pageTitle,
    });

    // Google Analytics (gtag.js) — the base <script> in public/index.html loads
    // with send_page_view: false, so every route change (current and future
    // pages alike, since this hook runs on every location change) sends its
    // own page_view event here instead of relying on the initial config call.
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pagePath,
        page_title: pageTitle,
        page_location: window.location.href,
      });
    }
  }, [location]);
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        {loading ? <Preloader /> : <AppContent />}
      </BrowserRouter>
    </>
  );
}

function AppContent() {
  const {
    authState: { loggedIn, data },
    userCoursesDispatch,
  } = useContext(GlobalContext);

  usePageTracking();
  useEffect(() => {
    if (loggedIn) {
      FetchUserCoureses(userCoursesDispatch);
    } else {
      userCoursesDispatch({ type: "RESET" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  return (
    <>
      <GoogleOAuthProvider clientId="1077958454111-kaqpn5cl373997strsunh6v8i9ms5e17.apps.googleusercontent.com">
        <StandaloneGuard />
        <Routes>
          <Route
            path="/"
            element={
              loggedIn && data?.user?.is_email_verified === false ? (
                <VerifyEmail />
              ) : (
                <LandingPage />
              )
            }
          />
          <Route path="/homepage-v2" element={<LandingPageV2 />} />
          <Route path="/about" element={<About />} />
          <Route path="instructors-upload" element={<Instructors />} />
          <Route path="/august/cohort" element={<AugustCohort />} />
          <Route path="/courses/categories" element={<Categories1 />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/checkout" element={<CheckOutPage />} />
          <Route path="/projects" element={<ProjectPage />} />
          <Route path="/payment-complete/:reference" element={<Callback />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/success" element={<SuccessfulPage />} />
          <Route path="/scholarships/:slug" element={<ScholarshipDetail />} />
          <Route path="/scholarships" element={<Scholarships />} />
          <Route path="/scholarships/:slug/pay" element={<ScholarshipPay />} />
          <Route path="/scholarships/pay" element={<ScholarshipPay />} />
          <Route
            path="/scholarship/payment-status"
            element={<ScholarshipPaymentStatus />}
          />
          <Route path="/courses" element={<Courses />} />
          <Route path="/online-course" element={<Courses />} />
          <Route path="/sponsor/apply" element={<SponsorApply />} />
          <Route path="/summer/registration" element={<SummerForm />} />
          <Route path="/online-course/:uuid" element={<CourseDetailV2 />} />
          <Route path="/courses/category/:uuid" element={<CoursePage />} />
          <Route path="/course-video/:uuid" element={<OnlineCourseDetail />} />
          <Route path="/live-course" element={<LiveCourses />} />
          <Route path="/sponsor/participate" element={<BecomeASposor />} />
          <Route path="/summer/apply" element={<SummerForm />} />
          <Route path="/waitlist/register" element={<JanuaryWaitList />} />
          <Route
            path="/waitlist/august/applyv2"
            element={<AugustWaitListv2 />}
          />
          <Route path="/live-course/:uuid" element={<CourseDetailV2 />} />
          <Route path="/course-detail-v2/:uuid" element={<CourseDetailV2 />} />
          <Route path="/sign-in" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/instructor/accept-invite/:token"
            element={<InstructorAcceptInvite />}
          />
          <Route
            path="/admin/accept-invite/:token"
            element={<AdminAcceptInvite />}
          />
          <Route path="/community" element={<Community />} />
          {/* <Route path="/signup" element={<SignUpPage />} /> */}
          {/* <Route path="/forgotpassword" element={<ResetPasswordPage />} /> */}
          <Route path="/sign-up" element={<SignUpPage />} />
          <Route path="/nysc" element={<Nysc />} />
          <Route path="/user/assignment/submit" element={<UploadAnswers />} />
          <Route path="/verify-email" element={<VerifyEmailComponent />} />
          <Route path="/verify-useremail" element={<VerifyEmailComponent />} />
          <Route path="/all-courses/:uuid" element={<VonAllCourses />} />
          <Route path="/profile" element={<Settings />} />
          <Route path="/webinars-events" element={<Events />} />
          <Route path="/events" element={<Navigate to="/webinars-events" replace />} />
          <Route path="/webinar-series" element={<Navigate to="/webinars-events" replace />} />
          <Route path="/webinar-events" element={<Navigate to="/webinars-events" replace />} />

          <Route
            path="/alumni-stories"
            element={
              <BlogProvider>
                <AlumniStory />
              </BlogProvider>
            }
          />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/talents" element={<Opportunity />} />
          <Route path="/talents/register" element={<MultiStepForm />} />
          <Route path="/talents/success" element={<ConfirmationPage />} />
          <Route path="/talents/login" element={<Login />} />
          <Route path="/talents/hire" element={<ConsultForm />} />
          <Route path="/talents/confirmation" element={<SuccessPage />} />
          <Route path="/terms" element={<TermsAndCondition />} />

          <Route
            path="/consultancy"
            element={
              <TrainersProvider>
                <Consultancy />
              </TrainersProvider>
            }
          />
          <Route path="/beta-cohort-schedule" element={<Schedule />} />
          <Route path="/pioneer-cohort-schedule" element={<PioneerCohortSchedule />} />
          <Route path="/partner-program" element={<PartnerProgram />} />

          {/* Dashboard */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <DashBoardNew />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/my-courses"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <StudentPageSwitch
                      student={<StudentMyCoursesPage />}
                      staff={<div className="py-6 px-4 md:px-8"><MyCourse /></div>}
                    />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/projects"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <StudentPageSwitch student={<StudentProjectsPage />} staff={<Projects />} />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/certificates"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <StudentPageSwitch student={<StudentCertificatesPage />} staff={<Certificates />} />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/settings"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <StudentPageSwitch student={<StudentSettingsPage />} staff={<Settings />} />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/instructor/courses"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <InstructorCourses />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/instructor/submissions"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <InstructorSubmissions />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/submissions/:submissionId/view"
            element={<PrivateRoute Element={<SubmissionViewerPage />} />}
          />
          <Route
            path="/dashboard/instructor/leaderboard"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <InstructorLeaderboardPage />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/sponsor" element={<Sponsor />} />
          <Route path="/ba-registration" element={<BaRegistration />} />
          <Route
            path="/data-analyst-may-cohort-2024-form"
            element={<FeedBack />}
          />
          <Route
            path="/data-analyst-may-cohort-form"
            element={<DataAnalyst />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/forgot-password" element={<ForgottenPasswordPage />} />
          <Route path="/invite" element={<Engagement />} />
          <Route path="/vonverify" element={<VonVerifyEmail />} />
          <Route
            path="/verify-certificate/:uuid"
            element={<VerifyCertificate />}
          />
          <Route path="/cohorts" element={<CohortEnrollment />} />
          <Route
            path="/dashboard/enroll"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <div className="max-w-4xl mx-auto px-4 md:px-8">
                      <div className="pt-6 pb-2">
                        <h1 className="text-2xl font-bold text-gray-900">
                          Enroll in a Course
                        </h1>
                        <p className="text-sm text-gray-500 mt-1">
                          Choose a cohort and course to get started.
                        </p>
                      </div>
                      <CohortEnrollment embedded />
                    </div>
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/subscriptions"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <SubscriptionsPage />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/leaderboard"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <LeaderboardPage />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/grades"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <StudentPageSwitch student={<StudentGradesPage />} staff={<GradesPage />} />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/cv-review"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <StudentPageSwitch student={<StudentCvReviewerPage />} staff={<CvReviewPage />} />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/job-board"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <StudentPageSwitch student={<StudentJobBoardPage />} staff={<JobBoardPage />} />
                  </DashboardLayout>
                }
              />
            }
          />
          {/* ── Admin routes ── */}
          {[
            ["/dashboard/admin/scholarships", <ScholarshipsPage />],
            ["/dashboard/admin/analytics", <AnalyticsPage />],
            ["/dashboard/admin/schedules", <AdminSchedulesPage />],
            ["/dashboard/admin/comments", <AdminCommentsPage />],
            ["/dashboard/admin/feedback", <AdminFeedbackPage />],
            ["/dashboard/admin/sponsors", <AdminSponsorsPage />],
            ["/dashboard/admin/partners", <AdminPartnersPage />],
            ["/dashboard/admin/faqs", <AdminFaqsPage />],
            ["/dashboard/admin/jobs", <AdminJobsPage />],
            ["/dashboard/admin/leaderboard", <AdminLeaderboardPage />],
            ["/dashboard/admin/students", <StudentsPage />],
            ["/dashboard/admin/subscriptions", <AdminSubscriptionsPage />],
            ["/dashboard/admin/courses", <AdminCoursesPage />],
            ["/dashboard/admin/cohorts", <AdminCohortsPage />],
            ["/dashboard/staff/progress", <StaffProgressPage />],
            ["/dashboard/staff/certificates", <StaffCertificatesPage />],
            ["/dashboard/staff/plans", <StaffPlansPage />],
            ["/dashboard/staff/plans/:cohortId/:courseId", <StaffPlanPage />],
            ["/dashboard/staff/weeks/:weekId", <StaffWeekPage />],
            ["/dashboard/staff/quizzes/:quizId", <StaffQuizPage />],
            ["/dashboard/staff/capstone", <StaffCapstonePage />],
            ["/dashboard/staff/live", <StaffLivePage />],
            ["/dashboard/staff/leaderboard", <StaffLeaderboardPage />],
          ].map(([path, el]) => (
            <Route
              key={path}
              path={path}
              element={
                <PrivateRoute
                  Element={<DashboardLayout>{el}</DashboardLayout>}
                />
              }
            />
          ))}
          <Route
            path="/dashboard/admin/scholarships/:scholarshipId/applications"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <ScholarshipApplicationsPage />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/admin/scholarships/applications"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <ScholarshipApplicationsPage />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/admin/courses/:courseId/cohorts/:cohortId"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <AdminCohortSchedulesPage />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/dashboard/admin/cohorts/:cohortId"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <AdminCohortCoursesPage />
                  </DashboardLayout>
                }
              />
            }
          />

          <Route path="/checkout/callback" element={<CheckoutCallback />} />
          <Route
            path="/dashboard/course/:uuid"
            element={
              <PrivateRoute
                Element={
                  <DashboardLayout>
                    <CoursePageSwitch />
                  </DashboardLayout>
                }
              />
            }
          />
          <Route
            path="/cohorts/checkout/callback"
            element={<CheckoutCallback />}
          />
          <Route
            path="/checkout/callback/:reference"
            element={<CheckoutCallback />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* Newsletter popup disabled */}
      </GoogleOAuthProvider>

      {/* {!isVonRenewPath && !isVonVerifyPath && !isSignInPath && !isSignUpPath && <CookieConsent />} */}
    </>
  );
}

//
// To https://github.com/edoubleone/e1xacademynew.git
//    3f97c99..9a6b522  main -> main
export default App;
